import { Button, Chip, Grid } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext, DependentsContext, ThemeContext } from "../../../../../contexts";
import { VEB_PLAN_NAMES } from "../../../../../constants/plan";
import EditWholeLifeBeneficiary from "../../../../pages/VEBEnrollment/editBeneficiary/editWholeLifeBeneficiary/EditWholeLifeBeneficiary";
import EditTermLifeToAge from "../../../../pages/VEBEnrollment/editBeneficiary/editTermLifeToAge/EditTermLifeToAge";
import { BV2Beneficiery } from "../../../../../types/BV2Beneficiery.types";
import EditIcon from "@mui/icons-material/Edit";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../utils/api";

type editBeneficiaryFormPropsType = {
	plan_type: string;
	plan_code: string;
	plan_name: string;
	base_plan_name: string | undefined;
	enrollments: any;
	handleOpenCloseEditBeneficiaryModal: () => void;
};

const EditBeneficiaryForm: React.FC<editBeneficiaryFormPropsType> = ({
	plan_type,
	plan_code,
	plan_name,
	base_plan_name,
	enrollments,
	handleOpenCloseEditBeneficiaryModal
}) => {
	const { member, setMember } = useContext(AuthContext);
	const { dependents, setDependents } = useContext(DependentsContext);

	const { theme } = useContext(ThemeContext);

	const [spouse, setSpouse] = useState<any>();

	// primary beneficiary
	const [employeePrimaryBeneficiary, setEmployeePrimaryBeneficiary] = useState<any[]>([]);
	const [childrenPrimaryBeneficiary, setChildrenPrimaryBeneficiary] = useState<any[]>([]);
	const [spousePrimaryBeneficiary, setSpousePrimaryBeneficiary] = useState<any[]>([]);

	// contingent beneficiary
	const [employeeContingentBeneficiary, setEmployeeContingentBeneficiary] = useState<any[]>([]);
	const [childrenContingentBeneficiary, setChildrenContingentBeneficiary] = useState<any[]>([]);
	const [spouseContingentBeneficiary, setSpouseContingentBeneficiary] = useState<any[]>([]);

	// individualEnrollment

	const [employeeEnrollment, setEmployeeEnrollment] = useState<any>(null);
	const [spouseEnrollment, setSpouseEnrollment] = useState<any>(null);
	const [childrenEnrollment, setChildrenEnrollment] = useState<any>(null);

	const coverageCodeConstant: any = {
		EE: "Employee Only",
		ES: "Employee & Spouse",
		ED: "Employee & Dependents",
		EF: "Employee & Family"
	};

	const coverage_for = coverageCodeConstant[enrollments[0].coverage_code];

	const validateBeneficiary = useCallback((beneficiary: BV2Beneficiery[], type: "PRIMARY" | "CONTINGENT") => {
		let sum = 0,
			i;
		for (i = 0; i < beneficiary.length; i++) {
			const { percentage } = beneficiary[i];
			sum += percentage;
		}
		return sum;
	}, []);

	const areArraysEqual = (arr1: any[], arr2: any[]) => {
		if (arr1.length !== arr2.length) return false;

		const normalize = (obj: any) => JSON.stringify(obj, Object.keys(obj).sort());

		const set1 = new Set(arr1.map(normalize));
		const set2 = new Set(arr2.map(normalize));

		return [...set1].every((item: any) => set2.has(item));
	};

	const validateChangeInBeneficiary = useCallback((): {
		isEmployeeBeneficiaryValid: boolean;
		isSpouseBeneficiaryValid: boolean;
		isChildrenBeneficiaryValid: boolean;
	} => {
		let isEmployeeBeneficiaryValid = true;
		let isSpouseBeneficiaryValid = spouseEnrollment && spouseEnrollment.length > 0 ? true : false;
		let isChildrenBeneficiaryValid = childrenEnrollment && childrenEnrollment.length > 0 ? true : false;
		if (employeeEnrollment && employeeEnrollment.length > 0) {
			isEmployeeBeneficiaryValid = !areArraysEqual(
				employeePrimaryBeneficiary,
				employeeEnrollment[0]["VEB_primary_beneficiary"]
			);

			isEmployeeBeneficiaryValid =
				isEmployeeBeneficiaryValid ||
				!areArraysEqual(employeeContingentBeneficiary, employeeEnrollment[0]["VEB_contingent_beneficiary"]);
		}
		if (spouseEnrollment && spouseEnrollment.length > 0) {
			isSpouseBeneficiaryValid = !areArraysEqual(
				spousePrimaryBeneficiary,
				spouseEnrollment[0]["VEB_primary_beneficiary"]
			);
			isSpouseBeneficiaryValid =
				isSpouseBeneficiaryValid ||
				!areArraysEqual(spouseContingentBeneficiary, spouseEnrollment[0]["VEB_contingent_beneficiary"]);
		}
		if (childrenEnrollment && childrenEnrollment.length > 0) {
			isChildrenBeneficiaryValid = !areArraysEqual(
				childrenPrimaryBeneficiary,
				childrenEnrollment[0]["VEB_primary_beneficiary"]
			);
			isChildrenBeneficiaryValid =
				isChildrenBeneficiaryValid ||
				!areArraysEqual(childrenContingentBeneficiary, childrenEnrollment[0]["VEB_contingent_beneficiary"]);
		}

		if (!isEmployeeBeneficiaryValid && !isSpouseBeneficiaryValid && !isChildrenBeneficiaryValid) {
			alert("you did not modify any data, no updates");
			handleOpenCloseEditBeneficiaryModal();
		}
		return { isEmployeeBeneficiaryValid, isSpouseBeneficiaryValid, isChildrenBeneficiaryValid };
	}, [
		childrenContingentBeneficiary,
		childrenEnrollment,
		childrenPrimaryBeneficiary,
		employeeContingentBeneficiary,
		employeeEnrollment,
		employeePrimaryBeneficiary,
		handleOpenCloseEditBeneficiaryModal,
		spouseContingentBeneficiary,
		spouseEnrollment,
		spousePrimaryBeneficiary
	]);

	const handleBeneficiaryValidate = useCallback(() => {
		let isValid = true;
		// console.log("validation beneficiary in edit", coverage_for);
		if (
			coverage_for === "Employee Only" ||
			coverage_for === "Employee & Spouse" ||
			coverage_for === "Employee & Dependents" ||
			coverage_for === "Employee & Family"
		) {
			// Primary Beneficiary
			if (employeePrimaryBeneficiary.length === 0) {
				alert("Employee must have alteast One Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (employeePrimaryBeneficiary.length > 4) {
				alert("Employee can have atmost Four Primary Beneficiaries!");
				isValid = false;
				return isValid;
			}
			const employeePrimaryPercentageSum = validateBeneficiary(employeePrimaryBeneficiary, "PRIMARY");
			if (employeePrimaryPercentageSum !== 100 && employeePrimaryPercentageSum !== 0) {
				alert("Primary Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (employeeContingentBeneficiary.length !== 0) {
				if (employeeContingentBeneficiary.length > 4) {
					alert("Employee can have atmost Four Contingent Beneficiaries!");
					isValid = false;
					return isValid;
				}

				const employeeContingentPercentageSum = validateBeneficiary(
					employeeContingentBeneficiary,
					"CONTINGENT"
				);
				if (employeeContingentPercentageSum !== 100 && employeeContingentPercentageSum !== 0) {
					alert("Contingent Beneficiary Percentage must be all total 100%!");
					isValid = false;
					return isValid;
				}
			}
		}
		if (coverage_for === "Employee & Spouse" || coverage_for === "Employee & Family") {
			// Primary Beneficiary
			if (spousePrimaryBeneficiary.length === 0) {
				alert("Spouse must have alteast one Primary Beneficiary!");
				isValid = false;
				return isValid;
			}
			if (spousePrimaryBeneficiary.length > 4) {
				alert("Spouse can have atmost Four Primary Beneficiaries!");
				isValid = false;
				return isValid;
			}
			const spousePrimaryPercentageSum = validateBeneficiary(spousePrimaryBeneficiary, "PRIMARY");
			if (spousePrimaryPercentageSum !== 100 && spousePrimaryPercentageSum !== 0) {
				alert("Spouse Beneficiary Percentage must be all total 100%!");
				isValid = false;
				return isValid;
			}

			// Contingent Beneficiary
			if (spouseContingentBeneficiary.length !== 0) {
				if (spouseContingentBeneficiary.length > 4) {
					alert("Spouse can have atmost Four Contingent Beneficiary!");
					isValid = false;
					return isValid;
				}

				const contingentPercentageSum = validateBeneficiary(spouseContingentBeneficiary, "CONTINGENT");
				if (contingentPercentageSum !== 100 && contingentPercentageSum !== 0) {
					alert("Contingent Beneficiary Percentage must be all total 100%!");
					isValid = false;
					return isValid;
				}
			}
		}
		if (coverage_for === "Employee & Dependents" || coverage_for === "Employee & Family") {
			// console.log("running for children 1");
			if (childrenEnrollment && childrenEnrollment.length > 0) {
				// console.log("running for children 2", childrenPrimaryBeneficiary, childrenContingentBeneficiary);
				// Primary Beneficiary
				if (childrenPrimaryBeneficiary.length === 0) {
					alert("Children must have alteast one Primary Beneficiary!");
					isValid = false;
					return isValid;
				}
				if (childrenPrimaryBeneficiary.length > 4) {
					alert("Children can have atmost Four Primary Beneficiaries!");
					isValid = false;
					return isValid;
				}
				const childrenPrimaryPercentageSum = validateBeneficiary(childrenPrimaryBeneficiary, "PRIMARY");
				if (childrenPrimaryPercentageSum !== 100 && childrenPrimaryPercentageSum !== 0) {
					alert("Children Beneficiary Percentage must be all total 100%!");
					isValid = false;
					return isValid;
				}

				// Contingent Beneficiary
				if (childrenContingentBeneficiary.length !== 0) {
					if (childrenContingentBeneficiary.length > 4) {
						alert("Children can have atmost Four Contingent Beneficiary!");
						isValid = false;
						return isValid;
					}

					const contingentPercentageSum = validateBeneficiary(childrenContingentBeneficiary, "CONTINGENT");
					if (contingentPercentageSum !== 100 && contingentPercentageSum !== 0) {
						alert("Contingent Beneficiary Percentage must be all total 100%!");
						isValid = false;
						return isValid;
					}
				}
			}
		}

		return isValid;
	}, [
		coverage_for,
		employeePrimaryBeneficiary,
		validateBeneficiary,
		employeeContingentBeneficiary,
		spousePrimaryBeneficiary,
		spouseContingentBeneficiary,
		childrenEnrollment,
		childrenPrimaryBeneficiary,
		childrenContingentBeneficiary
	]);

	const handleEditBeneficiary = useCallback(async () => {
		const isValidBeneficiary = handleBeneficiaryValidate();
		const { isEmployeeBeneficiaryValid, isSpouseBeneficiaryValid, isChildrenBeneficiaryValid } =
			validateChangeInBeneficiary();
		console.log("isValidBeneficiary", isValidBeneficiary);
		if (
			isValidBeneficiary &&
			(isEmployeeBeneficiaryValid || isSpouseBeneficiaryValid || isChildrenBeneficiaryValid)
		) {
			// api calling for edit beneficiary
			const payload: any = {};
			payload["employee_SSN"] = employeeEnrollment[0].insured_SSN;
			payload["plan_type"] = plan_type;
			payload["group_number"] = employeeEnrollment[0].group_number;
			payload["plan_code"] = employeeEnrollment[0].plan_code;
			payload["base_plan_name"] = employeeEnrollment[0].base_plan_name;

			if (isEmployeeBeneficiaryValid) {
				payload["employee"] = {
					_id: employeeEnrollment[0]._id,
					VEB_primary_beneficiary: employeePrimaryBeneficiary,
					VEB_contingent_beneficiary: employeeContingentBeneficiary
				};
			}

			if (isSpouseBeneficiaryValid && spouseEnrollment && spouseEnrollment.length > 0) {
				payload["spouse"] = {
					_id: spouseEnrollment[0]._id,
					VEB_primary_beneficiary: spousePrimaryBeneficiary,
					VEB_contingent_beneficiary: spouseContingentBeneficiary
				};
			}

			if (isChildrenBeneficiaryValid && childrenEnrollment && childrenEnrollment.length > 0) {
				const childrenIds = childrenEnrollment.map((children: any) => children._id);
				payload["children"] = {
					_ids: childrenIds,
					VEB_primary_beneficiary: childrenPrimaryBeneficiary,
					VEB_contingent_beneficiary: childrenContingentBeneficiary
				};
			}

			try {
				const editBeneficiary = await trackPromise(api.beneficiary.editBeneficiary(payload));
				// console.log("edit beneficiary", childrenEnrollment);
				if (editBeneficiary) {
					alert("beneficiary updated");
					window.location.reload();
				} else {
					alert("something went wrong");
				}
			} catch (err) {
				alert(err);
			}
			handleOpenCloseEditBeneficiaryModal();
		}
	}, [
		childrenContingentBeneficiary,
		childrenEnrollment,
		childrenPrimaryBeneficiary,
		employeeContingentBeneficiary,
		employeeEnrollment,
		employeePrimaryBeneficiary,
		handleBeneficiaryValidate,
		handleOpenCloseEditBeneficiaryModal,
		plan_type,
		spouseContingentBeneficiary,
		spouseEnrollment,
		spousePrimaryBeneficiary,
		validateChangeInBeneficiary
	]);

	useEffect(() => {
		if (enrollments && enrollments.length > 0) {
			const employeeEnrollment = enrollments.filter(
				(enrollment: any) =>
					enrollment.base_plan_name == enrollment.plan_name && enrollment.insured_SSN == enrollment.member_SSN
			);
			setEmployeeEnrollment(employeeEnrollment);

			setEmployeePrimaryBeneficiary(
				employeeEnrollment[0]["VEB_primary_beneficiary"] ? employeeEnrollment[0]["VEB_primary_beneficiary"] : []
			);
			setEmployeeContingentBeneficiary(
				employeeEnrollment[0]["VEB_contingent_beneficiary"]
					? employeeEnrollment[0]["VEB_contingent_beneficiary"]
					: []
			);

			const spouseEnrollment = enrollments.filter(
				(enrollment: any) =>
					enrollment.base_plan_name == enrollment.plan_name && enrollment["member"].relationship == "SPOUSE"
			);

			if (spouseEnrollment && spouseEnrollment.length > 0) {
				setSpousePrimaryBeneficiary(
					spouseEnrollment[0]["VEB_primary_beneficiary"] ? spouseEnrollment[0]["VEB_primary_beneficiary"] : []
				);
				setSpouseContingentBeneficiary(
					spouseEnrollment[0]["VEB_contingent_beneficiary"]
						? spouseEnrollment[0]["VEB_contingent_beneficiary"]
						: []
				);
				setSpouseEnrollment(spouseEnrollment);
			}

			const childrenEnrollment = enrollments.filter(
				(enrollment: any) =>
					enrollment.base_plan_name == enrollment.plan_name &&
					(enrollment["member"].relationship == "CHILD" || enrollment["member"].relationship == "STEP CHILD")
			);

			if (childrenEnrollment && childrenEnrollment.length > 0) {
				setChildrenPrimaryBeneficiary(
					childrenEnrollment[0]["VEB_primary_beneficiary"]
						? childrenEnrollment[0]["VEB_primary_beneficiary"]
						: []
				);
				setChildrenContingentBeneficiary(
					childrenEnrollment[0]["VEB_contingent_beneficiary"]
						? childrenEnrollment[0]["VEB_contingent_beneficiary"]
						: []
				);
				setChildrenEnrollment(childrenEnrollment);
				// console.log("primary contingenet", childrenEnrollment);
			}
			// console.log("enrollments", enrollments);
		}
	}, [enrollments]);

	// console.log("plan_type", plan_type);

	useEffect(() => {
		const spouseDetails = dependents.find((dependent, index) => dependent.relationship === "SPOUSE");
		if (spouseDetails) {
			setSpouse(spouseDetails);
		}
	}, [dependents]);

	return (
		<div>
			{enrollments &&
				enrollments.length > 0 &&
				(enrollments[0].base_plan_name == VEB_PLAN_NAMES.whole_life ? (
					<EditWholeLifeBeneficiary
						employeePrimaryBeneficiary={employeePrimaryBeneficiary}
						setEmployeePrimaryBeneficiary={setEmployeePrimaryBeneficiary}
						childrenPrimaryBeneficiary={childrenPrimaryBeneficiary}
						setChildrenPrimaryBeneficiary={setChildrenPrimaryBeneficiary}
						spousePrimaryBeneficiary={spousePrimaryBeneficiary}
						setSpousePrimaryBeneficiary={setSpousePrimaryBeneficiary}
						employeeContingentBeneficiary={employeeContingentBeneficiary}
						setEmployeeContingentBeneficiary={setEmployeeContingentBeneficiary}
						childrenContingentBeneficiary={childrenContingentBeneficiary}
						setChildrenContingentBeneficiary={setChildrenContingentBeneficiary}
						spouseContingentBeneficiary={spouseContingentBeneficiary}
						setSpouseContingentBeneficiary={setSpouseContingentBeneficiary}
						dependents={dependents}
						member={member}
						spouse={spouse}
						isChild={false}
						coverage_for={coverage_for}
					/>
				) : enrollments[0].base_plan_name == VEB_PLAN_NAMES.family_protection ? (
					<EditTermLifeToAge
						employeePrimaryBeneficiary={employeePrimaryBeneficiary}
						setEmployeePrimaryBeneficiary={setEmployeePrimaryBeneficiary}
						childrenPrimaryBeneficiary={childrenPrimaryBeneficiary}
						setChildrenPrimaryBeneficiary={setChildrenPrimaryBeneficiary}
						spousePrimaryBeneficiary={spousePrimaryBeneficiary}
						setSpousePrimaryBeneficiary={setSpousePrimaryBeneficiary}
						employeeContingentBeneficiary={employeeContingentBeneficiary}
						setEmployeeContingentBeneficiary={setEmployeeContingentBeneficiary}
						childrenContingentBeneficiary={childrenContingentBeneficiary}
						setChildrenContingentBeneficiary={setChildrenContingentBeneficiary}
						spouseContingentBeneficiary={spouseContingentBeneficiary}
						setSpouseContingentBeneficiary={setSpouseContingentBeneficiary}
						dependents={dependents}
						member={member}
						spouse={spouse}
						isChild={false}
						coverage_for={coverage_for}
					/>
				) : (
					<></>
				))}

			<Grid item marginTop={2}>
				<Grid container spacing={1} alignItems="flex-end" justifyContent="flex-end">
					<Grid item>
						<Button
							style={{ backgroundColor: theme.button.background_color, color: theme.button.color }}
							onClick={handleEditBeneficiary}
							variant="contained"
						>
							Update Beneficiary
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
};

export default EditBeneficiaryForm;
